import $ from 'jquery';
// import { breakpoints } from './_site';

export const activate = () => {
    let $headerRibbon = $('.header-ribbon');

    if ($headerRibbon.length) {
        $('body').addClass('header-ribbon-active');
    }
};
export const binds = () => {
    activate();
};
